module.exports = __webpack_public_path__ + "img/genre_electro.60301ad0.png";